import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Link, useRouteMatch } from 'react-router-dom'

import { SurveyApi } from '@trivie/core/src/services/api-objects'
import { GridCellParams } from '@mui/x-data-grid-pro'
import { initColumns } from '@trivie/ui-web/components/data-table/configure'
import { Toolbar } from '@trivie/ui-web/components/table-toolbar'
import { DownloadRounded } from '@mui/icons-material'
import { DataTable } from '@trivie/ui-web/components/data-table'
import { CircularProgress } from '@mui/material'
import { useStores } from '@trivie/core'

const Surveys = observer(() => {
  const { surveyStore } = useStores()
  const { exportResponses } = surveyStore
  const match = useRouteMatch<any>('/content/paths/:id/surveys')
  const pathID = Number(match?.params?.id)

  const [loading, setLoading] = useState(true)
  const [surveys, setSurveys] = useState([])
  const [selectedRows, setSelectedRows] = useState<any>([])
  const [tableActions, setTableActions] = useState<any>([])

  const { columns } = initColumns([
    {
      field: 'title',
      headerName: 'Title',
      description: 'Title of the subscription',
      data_type: 'str',
      width: 200,
      renderCell: (params: GridCellParams) => (
        <Link
          style={{
            display: 'block',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
          to={`/activities/surveys/live/${params.id}/overview`}
        >
          {params.formattedValue as string}
        </Link>
      ),
    },
  ])

  const loadSurveys = async () => {
    setLoading(true)
    const resp = await SurveyApi.getPathSurveyes(pathID)
    if (resp) {
      setSurveys(resp.data.surveys.map((s) => ({ ...s, id: s.survey_id })))
    }
    setLoading(false)
  }

  useEffect(() => {
    loadSurveys()
  }, [])

  const exportSurveyResponses = async () => {
    const { file_url } = (await exportResponses(selectedRows[0])) as any
    window.open(file_url)
  }

  const getActions = () => {
    return [
      {
        label: 'Export Responses',
        icon: DownloadRounded,
        onClick: exportSurveyResponses,
        disabled: selectedRows.length !== 1,
      },
    ]
  }

  useEffect(() => {
    setTableActions(getActions())
  }, [selectedRows])

  return loading ? (
    <div style={{ flex: 1, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
      <CircularProgress />
    </div>
  ) : (
    <DataTable
      toolbar={<Toolbar selected={selectedRows} actions={tableActions} />}
      searchPlaceholder="Search subscriptions"
      columns={columns as any}
      rows={surveys}
      getRowId={(row) => row.id}
      onRowSelectionModelChange={(param) => setSelectedRows(param)}
      rowSelectionModel={selectedRows}
      onSaveFilters={() => {}}
    />
  )
})

export const PathSurveysTab = (props: any) => {
  const { id } = props
  return {
    name: 'Surveys',
    path: `/content/paths/${id}/surveys`,
    component: () => <Surveys />,
  }
}
